import { store } from '../../App'
import { FAIL_FETCH } from './Other'
export const FETCH_CONTENT_IMPRESSION_STATS = 'FETCH_CONTENT_IMPRESSION_STATS'
export const LOAD_CONTENT_IMPRESSION_STATS = 'LOAD_CONTENT_IMPRESSION_STATS'

/**
 * fetchContentImpressionStats
 * @desc generate a fetch action for content-specific impression stats
 * @param {string} accountId account ID
 * @param {string} startDate start date
 * @param {string} endDate end date
 * @param {Array} entityIds content/entity IDs
 * @param {Object} options additional query options
 * @return {action} action
 */
export function fetchContentImpressionStats (accountId, startDate, endDate, entityIds, options = {}) {
  const query = { accountId, startDate, endDate, entityIds }
  if (options.profile && options.profile[0].length > 0) {
    query.appProfileIds = options.profile
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.appProfileIds = store.getState().filterSources.profiles.map(profile => profile._id)
  }
  if (options.group && options.group[0].length > 0) {
    query.groupIds = options.group
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.groupIds = ['AllGROUPS']
  }
  if (options.appType) {
    query.appType = options.appType
  } else {
    query.appType = 'ALL'
  }
  console.log('Fetching content impression stats with query:', query)
  return {
    type: FETCH_CONTENT_IMPRESSION_STATS,
    query
  }
}

/**
 * loadContentImpressionStats
 * @desc Load content-specific impression stats result
 * @param {Object} data data to load
 * @return {action} loadContentImpressionStatsAction
 */
export function loadContentImpressionStats (data) {
  return {
    type: LOAD_CONTENT_IMPRESSION_STATS,
    data
  }
}
